<template>
    <div id="overlay">
        <div class="d-flex align-items-center dialog_height">
        <div class='mypage-friend-input'>
            <h4 class='p-3'>{{ btnName }}</h4>
            <div class="pb-3">
                <div class="pl-3 mb-2">●お友達のお名前、メールアドレス、携帯番号（ハイフンなし）を入力してください。</div>
                <div class="container mb-4">
                    <div class="row mb-2">
                        <div class="col-sm-4">
                            <label for="inputFamilyName" class="pt-1">お名前</label>
                        </div>
                        <div class="col-sm-3">
                            <input
                                id="inputFamilyName"
                                placeholder="姓"
                                type="text"
                                class="form-control mb-1"
                                v-model.trim="inputFamilyName"
                            >
                        </div>
                        <div class="col-sm-3">
                            <input
                                type="text"
                                placeholder="名"
                                class="form-control"
                                v-model.trim="inputGivenName"
                            >
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-4">
                            <label
                                for="inputEmail"
                                class="pt-1"
                            >メールアドレス</label>
                        </div>
                        <div class="col-sm-6">
                            <input
                                id="inputEmail"
                                placeholder="メールアドレス"
                                type="email"
                                class="form-control mb-1"
                                v-model.trim="inputEmail"
                            >
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <label
                                for="inputMobileNumber"
                                class="pt-1"
                            >携帯番号</label>
                        </div>
                        <div class="col-sm-6">
                            <input
                                id="inputMobileNumber"
                                placeholder="携帯番号※ハイフンなし"
                                type="numeric"
                                class="form-control"
                                v-model.trim="inputMobileNumber"
                            >
                        </div>
                        <div class="col-sm-2">
                        </div>
                    </div>
                </div>
                <div class="row row-notMx justify-content-center px-3">
                    <button
                        class="bluebackbutton col-sm-3 mb-2 mr-sm-2"
                        v-on:click="addOverlayDisplay"
                    >{{ btnName }}</button>
                    <button class="mypagebackbutton col-sm-3 mb-2" v-on:click="closeEvent">閉じる</button>
                </div>
            </div>
            <ConfirmDialog
                v-if="addDialog === true"
                initialMessage="この友達を登録しますか？"
                doing="登録"
                notDoing="閉じる"
                :processing="processing"
                @from-Dialog="registGolfFriend"
                @closeBtn="addOverlayHidden"
            />
            <ErrorDialog
                v-show="showError"
                v-bind:errorWording="errorMessage"
                v-on:closeErrorDialog="closeErrorDialog"
            ></ErrorDialog>
        </div>
        </div>
    </div>
</template>

<script>
import {
    REGIST_GOLF_FRIEND,
    UPDATE_GOLF_FRIEND,
    GET_FRIEND_LIST,
    GET_MEMBER_BY_EMAIL,
    GET_MEMBER_BY_MOBILE_NUMBER } from '../../constants/golf_friend';
import ConfirmDialog from './ConfirmDialog';
import ErrorDialog from './ErrorDialog';
import validater from '../../lib/validater';

export default {
    components: {
        validater,
        ConfirmDialog,
        ErrorDialog
    },
    props:['memberData', 'editMode'],
    data () {
        return {
            btnName: '',
            inputEmail: '',
            inputMobileNumber: '',
            inputFamilyName: '',
            inputGivenName: '',
            inputFriendId: 0,
            friend_member_no: 0,
            addDialog: false,
            editDialog: false,
            // エラーダイアログ表示フラグ
            showError: false,
            errorMessage: '',
            friendList: [],
            // 処理の結果のオブジェクト
            processing: {
                result: '',
                resultText: '',
                btnDisabled: 0,
            },
            oldRegistedEmail: '',
            oldRegistedMobileNumber: '',
            result: false,
            loadingCount: 0
        };
    },
    created () {
        if (this.memberData.friendId == 0 || !this.memberData.friendId) {
            this.btnName = 'お友達登録';
        } else {
            this.btnName = 'お友達編集';
        }
        this.memberNo = this.$store.state.auth.loginMember.member_no;
        this.inputEmail = this.memberData.email;
        this.inputMobileNumber = this.memberData.mobileNumber;
        this.inputFamilyName = this.memberData.familyName;
        this.inputGivenName = this.memberData.givenName;
        this.inputFriendId = this.memberData.friendId;
        this.friend_member_no = this.memberData.friendMemberNo;
        this.oldRegistedEmail = this.memberData.email;
        this.oldRegistedMobileNumber = this.memberData.mobileNumber;
        this.getFriendList();
    },
    methods: {
        /** ----------------------------------------------
         * 友達一覧を取得
         * ---------------------------------------------- */
        getFriendList () {
            var me = this;
            this.loadingOn();
            me.$apollo.query({
                fetchPolicy: 'no-cache',
                query: GET_FRIEND_LIST,
                variables: {
                    member_no: me.memberNo,
                    limit: 10000,
                    offset: 0
                }
            }).then(res => {
                const data = res.data.getGolfFriendList.GolfFriendList;
                me.friendList = [];
                data.forEach(el => {
                    if (el.email) {
                        me.friendList.push(el.email);
                    }
                    if (el.mobile_number) {
                        me.friendList.push(el.mobile_number);
                    }
                });
                this.loadingOff();
            }).catch(error => {
                me.$set(me.processing, 'resultText', error);
                this.loadingOff();
            })
        },
        /** ----------------------------------------------
       * ゴルフ友達を登録
       * @param  {ID} memberNo
       * @param  {String} familyName
       * @param  {String} givenName
       * @param  {String} email
       * @param  {String} mobileNumber
       * @return {Boolean} result
       * @return {String} resultText
       * ---------------------------------------------- */
        registGolfFriend () {
            this.loadingOn();
            this.$set(this.processing, 'btnDisabled', 1);
            if (!this.editMode) {
                this.$apollo.mutate({
                    mutation: REGIST_GOLF_FRIEND,
                    variables: {
                        member_no: this.memberNo,
                        friend_family_name: this.inputFamilyName,
                        friend_given_name: this.inputGivenName,
                        email: this.inputEmail,
                        mobile_number: this.inputMobileNumber,
                        registedMemberFlag: false,
                        family_name: this.$store.state.auth.loginMember.family_name,
                        given_name: this.$store.state.auth.loginMember.given_name
                    }
                }).then(res => {
                    this.result = res.data.registGolfFriend.result;
                    this.$set(this.processing, 'result', 1);
                    this.addOverlayHidden();
                    this.closeEvent();
                    this.getFriendList();
                    this.$set(this.processing, 'btnDisabled', 0);
                    this.loadingOff();
                }).catch(error => {
                    this.showError = true;
                    // 登録に失敗しました。
                    this.errorMessage = '登録に失敗しました。';
                    this.$set(this.processing, 'btnDisabled', 0);
                    this.addDialog = !this.addDialog;
                    this.loadingOff();
                });
            } else {
                this.$apollo.mutate({
                    mutation: UPDATE_GOLF_FRIEND,
                    variables: {
                        id: this.inputFriendId,
                        member_no: this.memberNo,
                        friend_member_no: this.friend_member_no,
                        friend_family_name: this.inputFamilyName,
                        friend_given_name: this.inputGivenName,
                        email: this.inputEmail,
                        mobile_number: this.inputMobileNumber,
                        family_name: this.$store.state.auth.loginMember.family_name,
                        given_name: this.$store.state.auth.loginMember.given_name
                    }
                }).then(res => {
                    this.result = res.data.updateGolfFriend.result;
                    this.$set(this.processing, 'result', 1);
                    this.addOverlayHidden();
                    this.closeEvent();
                    this.getFriendList();
                    this.$set(this.processing, 'btnDisabled', 0);
                    this.loadingOff();
                }).catch(error => {
                    this.showError = true;
                    // 登録に失敗しました。
                    this.errorMessage = '登録に失敗しました。';
                    this.$set(this.processing, 'btnDisabled', 0);
                    this.addDialog = !this.addDialog;
                    this.loadingOff();
                });
            }
        },
        /** ----------------------------------------------
         * キャンセルダイアログを表示
         * ---------------------------------------------- */
        addOverlayDisplay: async function () {
            this.showError = false;
            this.errorMessage = '';
            if (!this.inputFamilyName || !this.inputGivenName) {
                this.errorMessage = this.errorMessage + 'お名前はフルネームで入力してください。\n';
            }
            if (this.inputEmail) {
                if (this.inputEmail != this.oldRegistedEmail || !this.oldRegistedEmail) {
                    if (this.friendList.includes(this.inputEmail)) {
                        this.errorMessage = this.errorMessage + '同一のメールアドレスが入力されています。\n';
                    }
                }
            }
            if (this.inputMobileNumber) {
                if (!validater.checkmobilenumberNoHyphen(this.inputMobileNumber)){
                    this.errorMessage = this.errorMessage + this.$t("error.validation.mobileNumber") + '\n';
                };
                if (this.inputMobileNumber != this.oldRegistedMobileNumber || !this.oldRegistedMobileNumber.length) {
                    if (this.friendList.includes(this.inputMobileNumber)) {
                        this.errorMessage = this.errorMessage + '同一の携帯番号が入力されています。\n';
                    }
                }
            }

            if (this.errorMessage === '') {
                this.addDialog = !this.addDialog;
            } else {
                this.showError = true;
                return;
            }

        },
        /** ----------------------------------------------
         * キャンセルダイアログを表示
         * ---------------------------------------------- */
        addOverlayHidden (data) {
          this.addDialog = !this.addDialog;
          this.$set(this.processing, 'result', '');
        },
        clickEvent (){
            this.$emit('from-TableDialog');
        },
        closeEvent () {
            this.friend_member_no = 0;
            this.$emit('close');
        },
        /** ----------------------------------------------
         * エラーダイアログを閉じる
         * ---------------------------------------------- */
        closeErrorDialog () {
            this.showError = false;
        },
        /** ----------------------------------------------
         * ローディング開始
         * ---------------------------------------------- */
        loadingOn: function　(){
            this.loadingCount++;
            this.$store.commit("loading/setIsLoading", true);
        },
        /** ----------------------------------------------
         * ローディング終了
         * ---------------------------------------------- */
        loadingOff: function　(){
            this.loadingCount--;
            if (this.loadingCount == 0) {
                this.$store.commit("loading/setIsLoading", false);
            }
        },
    }
}

</script>

<style scoped>
.dialog_height{
    height: 100%;
}
@media screen and (max-width: 896px) {
    .mypage-friend-input{
        height: 90%;
        width: 90%;
        margin: 10px auto;
        overflow-y: scroll;
    }
}

</style>
